<template>
  <!-- <div class="navbar">
      <el-menu
        class="el-menu-vertical-demo"
        @select="handleSelect"
        background-color="#001224"
        text-color="#fff"
        router
        active-text-color="#ffd04b"
        :collapse="isCollapse">
        <el-menu-item index="index">
          <i class="el-icon-view"></i>
          <span slot="title">系统首页</span>
        </el-menu-item>
        <el-menu-item :index="item.menuUrl" v-for="(item,index1) in firstMeans"  :key="item.menuName">
          <i :class="item.menuIcon"></i>
          <span slot="title">{{item.menuName}}</span>
        </el-menu-item>
        <el-submenu :index="item.menuName" v-for="(item,index) in hasTwoFirstMeans" :key="item.menuName">
          <template slot="title">
            <i :class="item.menuIcon"></i>
            <span slot="title">{{item.menuName}}</span>
          </template>
          <el-menu-item :index="item2.menuUrl" v-for="(item2,index2) in secondMeans" v-if="item.id===item2.topMenuID" :key="item2.menuName">
            <span slot="title">{{item2.menuName}}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div> -->
  <div class="navbar">
    <el-menu class="el-menu-vertical-demo"
             @select="handleSelect"
             background-color="#001224"
             text-color="#fff"
             active-text-color="#ffd04b"
             :default-active="defaultActive"
             :collapse="isCollapse">
      <router-link to="/index">
        <el-menu-item index="/index">
          <i class="el-icon-view"></i>
          <span slot="title">系统首页</span>
        </el-menu-item>
      </router-link>

      <router-link :to="{path: item.menuUrl, query: {menuId: item.id}}"
                   v-for="item in firstMeans"
                   :key="item.menuName">
        <el-menu-item :index="item.menuUrl">
          <i :class="item.menuIcon"></i>
          <span slot="title">{{item.menuName}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu :index="item.menuName"
                  v-for="item in hasTwoFirstMeans"
                  :key="item.menuName">
        <template slot="title">
          <i :class="item.menuIcon"></i>
          <span slot="title">{{item.menuName}}</span>
        </template>
        <router-link :to="{path: getIsHttp(item2.menuUrl), query: {menuId: item2.id}}"
                     v-for="(item2,index2) in secondMeans"
                     v-if="item.id === item2.topMenuID"
                     :key="index2">
          <el-menu-item :index="item2.menuUrl"
                        @click="getIsHttp(item2.menuUrl, 'open')">
            <span slot="title">{{item2.menuName}}</span>
          </el-menu-item>
        </router-link>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import host from '../../mixins/host.js'
export default {
  mixins: [host],
  data() {
    return {
      firstMeans: [],
      secondMeans: [],
      hasTwoFirstMeans: [],
      isCollapse: false,
      defaultActive: localStorage.getItem('defaultActive')
    }
  },
  methods: {
    getIsHttp(url, type) {
      if (url.includes('http://') || url.includes('https://')) {
        if (type) window.open(url)
        return ''
      }
      return url
    },
    handleSelect(index, path) {
      // this.activeIndex = index.slice(1)
      // console.log('index', path)
      if (path.length === 1) {
        this.defaultActive = path[0]
        if (!path[0].includes('http://') && !path[0].includes('https://')) {
          this.defaultActive = path[1]
        } else {
          const old = this.defaultActive
          this.defaultActive = ''
          setTimeout(() => {
            this.defaultActive = old
          }, 500)
        }
      } else if (path.length === 2) {
        if (!path[1].includes('http://') && !path[1].includes('https://')) {
          this.defaultActive = path[1]
        } else {
          const old = this.defaultActive
          this.defaultActive = ''
          setTimeout(() => {
            this.defaultActive = old
          }, 500)
        }
      }
      localStorage.setItem('defaultActive', this.defaultActive)
    },
    hasChildens(item, arr) {
      let index = 0
      for (let i = 0; i < arr.length; i++) {
        if (item === arr[i].topMenuID) {
          index++
        }
      }
      return index
    }
  },
  mounted() {
    // this.activeIndex = this.$route.fullPath.slice(1)
    const userId = window.localStorage.getItem('UserId')
    this.firstMeans = []
    this.secondMeans = []
    this.Axios.get('/api/User/GetUserJurisdiction/' + userId).then(res => {
      // console.log(res)
      if (res.status === 200 && res.data.data != 'undefined') {

        if (this.isZN) { // 专版控制
          res.data.data.forEach(item => {
            switch (item.menuName) {
              case '在线教学':
                item.menuName = '课程学习'
                break;
              case '远程会诊':
                item.menuName = '远程咨询'
                break;

              default:
                break;
            }
          })
        }

        // console.log(123, res.data.data)
        const firstPowers = res.data.data.filter(item => {
          return item.menuLevel === '一级菜单'
        })
        const secondPowers = res.data.data.filter(item => {
          return item.menuLevel === '二级菜单'
        })
        // console.log('二级菜单', secondPowers)
        this.firstMeans = firstPowers.filter(item => {
          return this.hasChildens(item.id, secondPowers) < 1
        })
        let twoChangeOne = secondPowers.filter(item => {
          return this.hasChildens(item.topMenuID, secondPowers) === 1
        })
        for (let i = 0; i < twoChangeOne.length; i++) {
          this.firstMeans.push(twoChangeOne[i])
        }

        const filterArr = ['/liveExtend_difficult', '/liveExtend_MDT', '/liveExtend_death']
        const filterArr1 = ['/notice']
        const filterArr2 = ['/liveExtend_difficult', '/liveExtend_MDT', '/liveExtend_death', '/notice']
        if (window.location.host === 'ncov.zkcis.com') {
          this.firstMeans = this.firstMeans.filter(item => {
            return filterArr.includes(item.menuUrl) || filterArr1.includes(item.menuUrl)
          })
        } else if (this.nameFlag) {
          this.firstMeans = this.firstMeans.filter(item => {
            return !filterArr2.includes(item.menuUrl)
          })
        } else {
          this.firstMeans = this.firstMeans.filter(item => {
            return this.isSctcm || !filterArr.includes(item.menuUrl)
          })
          this.hasTwoFirstMeans = firstPowers.filter(item => {
            return this.hasChildens(item.id, secondPowers) > 1
          })
          this.secondMeans = secondPowers
        }
      }
    })
  }
}
</script>

<style scoped lang="less">
.navbar {
  position: relative;
  z-index: 9;
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  width: 100%;
  .el-menu {
    height: 100%;
    border: 0;
    /deep/ .is-active {
      background-color: #1890ff !important;
      color: rgba(255, 255, 255, 1) !important;
    }
    .el-menu-item {
      color: rgba(255, 255, 255, 0.65);
    }
    .el-submenu {
      /deep/ .el-submenu__title {
        color: #fff;
      }
    }
  }
}
.el-menu--vertical {
  .el-menu-item {
    color: white !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue